import { useEffect } from 'react';
import { useBrandProfile } from '@/shared/hooks/useBrandProfile';
import { useOccasionSettings } from '@/shared/hooks/useOccasions';
import { setFormattingRegion } from '@/shared/lib/intl';

/**
 * Dates and numbers follow the brand's country when the UI language has no
 * region of its own (a brand in India on an en-US browser read 11/02/2026 for
 * 2 November): the brand profile's country, else the occasion calendar's.
 * Mounted once, in the app shell.
 */
export function useFormattingRegion(): void {
  const profile = useBrandProfile();
  const occasions = useOccasionSettings();
  const country = profile.data?.country || occasions.data?.country || null;
  const settled = !profile.isLoading && !occasions.isLoading;
  useEffect(() => {
    // Kept until the brand's answer is in: a brand switch must not flash the browser's order.
    if (country || settled) setFormattingRegion(country);
  }, [country, settled]);
}
